import { ComponentType, lazy } from 'react';

const LAST_RELOAD_KEY = 'eve-client:last-chunk-reload';
const RELOAD_WINDOW_MS = 60_000;

// Recover stale route chunks after a deploy while limiting reloads across all routes in this tab.
export function lazyWithReload<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
    return lazy(() =>
        load().catch((error) => {
            if (error?.name !== 'ChunkLoadError' && error?.code !== 'CSS_CHUNK_LOAD_FAILED') {
                throw error;
            }

            try {
                const now = Date.now();
                const lastReload = window.sessionStorage.getItem(LAST_RELOAD_KEY);
                if (lastReload !== null && now - Number(lastReload) < RELOAD_WINDOW_MS) {
                    throw error;
                }

                window.sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
                window.location.reload();
            } catch {
                throw error;
            }

            // Navigation is asynchronous; keep Suspense visible until the new document takes over.
            return new Promise<{ default: T }>(() => {});
        }),
    );
}
